import axios from 'axios';
import store from '@state/store';
import router from '../router';
import config from '../config';

export const axiosInstance = axios.create({
  baseURL: config.api.baseURL,
  timeout: 120000,
  headers: {
    Accept: 'application/json',
  },
});

function makeRequest(meta) {
  const { url, method = 'get', params, headers, data, ...rest } = meta;
  let requestHeaders = headers || {};

  store.dispatch('auth/validateToken');
  let token = store.getters['auth/token'];
  const refreshToken = store.getters['auth/refreshToken'];

  if (token && token.access_token) {
    requestHeaders = {
      ...requestHeaders,
      Authorization: `Bearer ${token.access_token}`,
    };
  } else if (refreshToken) {
    store.dispatch('auth/getNewToken');
    token = store.getters['auth/token'];
  }

  const httpOptions = {
    method: method.toLowerCase(),
    url,
    params,
    headers: requestHeaders,
    data,
    ...rest,
  };

  return new Promise((resolve, reject) => {
    axiosInstance.request(httpOptions)
      .then(resolve)
      .catch((error) => {
        const hadBearerToken = httpOptions.headers && httpOptions.headers.Authorization;

        if (error.response && error.response.status === 401 && hadBearerToken) {
          // Unauthorized user, dispatch logout action
          store.dispatch('auth/logOut')
            .then(() => {
              router.push('/login');
              window.location.reload();
            });
        }

        reject(error);
      });
  });
}

export default makeRequest;
